import { Controller } from "@hotwired/stimulus"

// Smooth scroll for in-page anchors. CSS scroll-behavior on <html> is
// off-limits (it breaks Turbo's scroll restoration) — see docs/FRONTEND.md.
export default class extends Controller<HTMLAnchorElement> {
  scroll(event: Event) {
    if (!this.element.hash) return
    const target = document.querySelector(this.element.hash)
    if (!target) return

    event.preventDefault()
    target.scrollIntoView({ behavior: "smooth", block: "start" })
  }
}
